import { MDCFormField } from '@material/form-field'
import { MDCRadio } from '@material/radio'

export default {
  setup() {
    this.radio = new MDCRadio(this.el.querySelector('.mdc-radio'))
    this.formField = new MDCFormField(this.el)
    this.formField.input = this.radio
  },
  destroy() {
    this.formField?.destroy()
    this.formField = null
    this.radio?.destroy()
    this.radio = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
